import type { FC } from 'react'

import styles from './PartnerSummaryBlock.module.scss'

export interface PartnerSummaryBlockProps {
  partnerName?: string
  region?: string
  country?: string
  pid?: string
  locationId?: string
  className?: string
  truncateName?: boolean
  inlineIds?: boolean
}

export const PartnerSummaryBlock: FC<PartnerSummaryBlockProps> = ({
  partnerName,
  region,
  country,
  pid,
  locationId,
  className,
  truncateName = false,
  inlineIds = false,
}) => {
  if (!partnerName) {
    return null
  }

  return (
    <div className={[styles.root, className].filter(Boolean).join(' ')}>
      {(region || country) && (
        <p className={styles.region}>{[region, country].filter(Boolean).join(', ')}</p>
      )}
      <p
        className={[styles.name, truncateName ? styles.nameTruncated : '']
          .filter(Boolean)
          .join(' ')}
        title={truncateName ? partnerName : undefined}
      >
        {partnerName}
      </p>
      {(pid || locationId) && (
        <p className={[styles.ids, inlineIds ? styles.idsInline : ''].filter(Boolean).join(' ')}>
          {pid && <>PID {pid}</>}
          {pid && locationId && ', '}
          {locationId && <>Loc ID {locationId}</>}
        </p>
      )}
    </div>
  )
}
